import { Box, CircularProgress, Typography } from '@mui/material';

function SkillPercentageProgress({ value }: { value: number }) {
  const percent = Math.max(0, Math.min(100, Math.round(value)));

  return (
    <Box
      sx={{
        width: 34,
        height: 34,
        position: 'relative',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
      }}
      aria-label={`${percent} percent`}
    >
      <CircularProgress variant="determinate" value={percent} size={34} thickness={5} />
      <Typography
        component="span"
        variant="caption"
        color="text.secondary"
        sx={{ position: 'absolute', fontWeight: 700, fontSize: '0.6rem', lineHeight: 1 }}
      >
        {`${percent}%`}
      </Typography>
    </Box>
  );
}

export default SkillPercentageProgress;
